import { render, staticRenderFns } from "./riskWarn.vue?vue&type=template&id=09cd989c&scoped=true&"
import script from "./riskWarn.vue?vue&type=script&lang=js&"
export * from "./riskWarn.vue?vue&type=script&lang=js&"
import style0 from "./riskWarn.vue?vue&type=style&index=0&id=09cd989c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cd989c",
  null
  
)

export default component.exports